/**
 * Feature flags do frontend.
 */

export const FEATURE_FLAGS = {
  // Default ligado para evitar bypass por role em ambientes sem .env configurado.
  // Para desativar explicitamente: REACT_APP_ENABLE_GRANULAR_PERMISSIONS=false
  granularPermissions: String(process.env.REACT_APP_ENABLE_GRANULAR_PERMISSIONS || "true").toLowerCase() === "true",
};

export default FEATURE_FLAGS;

